export default {
      id: "covid-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#covid",
      toString: function () {
        return this.url;
      }
    }